import SwitchToAirtel from './SwitchToAirtel';

export default SwitchToAirtel;
